import * as React from "react";
const SvgRightSidebarFilled = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 22V2h20v20H2ZM14 4H4v16h10V4Z",
  fill: "currentColor"
}));
export default SvgRightSidebarFilled;